import { MetricNumber } from '@/components/data-truth/MetricNumber'
import { ProvenanceChip } from '@/components/data-truth/ProvenanceChip'
import { UnknownValue } from '@/components/data-truth/UnknownValue'
import { Sparkline } from '@/components/charts/Sparkline'
import { useHomeDashboard } from '@/api/queries'
import type { WidgetSpan } from '../Widget'
import { Widget } from '../Widget'

const SPARK_COLOR: Record<'good' | 'bad' | 'neutral', string> = {
  good: '#059669',
  bad: '#dc2626',
  neutral: '#5c5c66',
}

export function KpiStripWidget({ span = 12 }: { span?: WidgetSpan }) {
  const { data, isLoading } = useHomeDashboard()

  return (
    <Widget title="Fleet health strip" span={span} bodyPadding={false}>
      <div className="grid grid-cols-8 gap-px overflow-hidden rounded-b-[10px] bg-border">
        {isLoading || !data
          ? Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="h-[92px] animate-pulse bg-surface" />
            ))
          : data.kpis.map((kpi) => (
              <div key={kpi.label} className="bg-surface p-3">
                <div className="flex items-center justify-between">
                  <div className="text-[10.5px] font-bold tracking-wide text-ink-2 uppercase">{kpi.label}</div>
                  <ProvenanceChip provenance={kpi.provenance} />
                </div>
                {kpi.unknown || kpi.value === null ? (
                  <div className="mt-1.5">
                    <UnknownValue reason={kpi.provenance.note} />
                  </div>
                ) : (
                  <>
                    <MetricNumber value={kpi.value} unit={kpi.unit} delta={kpi.delta} className="mt-1" />
                    {kpi.spark && (
                      <div className="mt-1.5">
                        <Sparkline data={kpi.spark} color={SPARK_COLOR[kpi.delta?.tone ?? 'neutral']} />
                      </div>
                    )}
                  </>
                )}
              </div>
            ))}
      </div>
    </Widget>
  )
}
